import StepOpen from "./StepOpen";
import proxy from "api/proxy";
import funcs from "tools/functions";
import { useWizard } from "storev2/wizardStore";

const fields = ["id", "name"];
const model = "account.statement";

async function getDevice() {
  const terminal = funcs.getCookie();
  const dom = [["code", "=", terminal.device_code]];
  const { data } = await proxy.search("sale.device", dom, fields);
  const device = data.length > 0 ? data[0] : null;
  return device;
}

async function onAcceptOpen() {
  let next = "success";
  const { store } = useWizard.getState();
  let msgError = null;
  const method = "do_open_statement";
  const device = await getDevice();
  if (!device) {
    // Add raise error message
    return { next: "error", msgError: "No existe un terminal" };
  }
  const args = [
    {
      device: device.id,
      start_balance: store.start_balance,
    },
  ];

  const { error } = await proxy.methodCall({ model, method, args });
  if (error) {
    next = "error";
    msgError = error.error;
  }
  return { next, msgError };
}

function handleClose() {}

const closeBtn = { name: "close", handleClick: handleClose };

const openStatementViews = {
  start: {
    label: "open_start",
    Component: StepOpen,
    msg: "account.statement.open.msg_start",
    initialStore: { start_balance: 0 },
    buttons: [closeBtn, { name: "ok", handleClick: onAcceptOpen }],
  },
  success: {
    label: "open_success",
    msg: "account.statement.open.msg_success",
    buttons: [closeBtn],
  },
  error: {
    label: "open_error",
    buttons: [closeBtn],
  },
};

export { openStatementViews };
